import React, { FC, useContext, useEffect } from 'react'
import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs'
import Details from 'containers/VerticalPage/serviceProviders/Details/Details'
import Content from 'containers/VerticalPage/serviceProviders/Content/Content'
import VerticalDetailsContextProvider from 'store/verticalsDetails/Context'
import VerticalPageWrapper from 'containers/VerticalPage/common/VerticalPageWrapper/VerticalPageWrapper'
import { CurrentZone } from 'utils/types'
import { selectCurrentZone } from 'store/global'
import { useSelector } from 'react-redux'
import { VerticalContext } from 'store/verticals/Context'
import { changeCurrentZoneIndexesFunc } from 'containers/VerticalPage/common/utils'
import { NetworkGraphButton } from 'components/network-graph/NetworkGraphButton'

const VerticalPage = (props: { changeCurrentZoneIndexes: changeCurrentZoneIndexesFunc }) => {
  const currentZone: CurrentZone = useSelector(selectCurrentZone)
  const { verticalEntity } = useContext(VerticalContext)

  useEffect(() => {
    props.changeCurrentZoneIndexes({
      baseIndices: currentZone?.serviceProvidersIndices,
      activityIndices: currentZone?.serviceProvidersActivityIndices,
    })
  }, [currentZone])

  return (
    <VerticalPageWrapper
      gridContainerSx={{
        gridTemplateColumns: '100%',
      }}
      breadcrumbs={
        <Breadcrumbs
          data={[
            { label: 'Home', href: '/' },
            { label: 'Service Providers', href: '/service-providers' },
            { label: verticalEntity?.entityDetails?.name || 'N/A' },
          ]}
        />
      }
      headerAction={<NetworkGraphButton />}
    >
      <Content />
      <VerticalDetailsContextProvider>
        <Details />
      </VerticalDetailsContextProvider>
    </VerticalPageWrapper>
  )
}

export default VerticalPage
